let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gMXgB")).then(() => parcelRequire('b2zWf'));